import { render, staticRenderFns } from "./v-foot.vue?vue&type=template&id=18ddcbdf&scoped=true&"
import script from "./v-foot.vue?vue&type=script&lang=js&"
export * from "./v-foot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ddcbdf",
  null
  
)

export default component.exports